import axios from "axios";

const BASE_URL =
  process.env.NODE_ENV === "development" ? "" : process.env.REACT_APP_API_BASE_URL || "";

export const uploadService = {
  uploadEventFiles: async (slug, files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    const { data } = await axios.post(
      `${BASE_URL}/api/uploads/events/${encodeURIComponent(slug)}`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      }
    );
    return data; // [{url,label}]
  },

  uploadArticleFiles: async (slug, files) => {
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    const { data } = await axios.post(
      `${BASE_URL}/api/uploads/articles/${encodeURIComponent(slug)}`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      }
    );
    return data; // [{url,label}]
  },
};

export default uploadService;
